module.exports = __webpack_public_path__ + "img/st-james.8e406167.jpg";